module.exports = __webpack_public_path__ + "static/media/LeftPROJECTSBackgroundSpots.7d795924.png";